import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { WidgetWrapperModule } from 'app/views/presentations/widgets/widgetWrapper.module';
import { SharedModule } from './../../../../components/shared.module';
import { WebpageWidget, WebpageWidgetComponent } from './webpage.widget';

@NgModule({
    imports: [
        TranslateModule,
        FormsModule,
        ReactiveFormsModule,
        SharedModule,
        CommonModule,
        WidgetWrapperModule.wrapWidget(WebpageWidget)
    ],
    declarations: [
        WebpageWidgetComponent
    ],
    entryComponents: [
        WebpageWidgetComponent
    ]
})
export class WebpageWidgetModule { }



// WEBPACK FOOTER //
// ./src/app/views/presentations/widgets/webpage/webpage.module.ts